import React from 'react';

const ControlPanel = (props) => {
  const { pageNumber, numPages, setPageNumber, scale, setScale } = props;

  const isFirstPage = pageNumber === 1;
  const isLastPage = pageNumber === numPages;

  const firstPageClass = isFirstPage ? 'disabled' : 'clickable';
  const lastPageClass = isLastPage ? 'disabled' : 'clickable';

  const goToPreviousPage = () => {
    if (!isFirstPage) setPageNumber(pageNumber - 1);
  };
  const goToNextPage = () => {
    if (!isLastPage) setPageNumber(pageNumber + 1);
  };

  return (
    <div className="control-panel">
        <button type="button" onClick={goToPreviousPage} className="control-panel-button cursor-pointer">
            {"<"}
        </button>
        <span> {pageNumber} de {numPages} </span>
        <button type="button" onClick={goToNextPage} className="control-panel-button cursor-pointer">
            {">"}
        </button>
    </div>
  );
};

export default ControlPanel;